import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useAnnieDisplayName } from "@/hooks/useAnnieAvatar";

/** The Annie menu entry's label ("Ask Nova"); its own component so the name loads only when the entry shows. */
export const AnnieMenuLabel: FC = () => {
	const { t } = useTranslation();
	const annieName = useAnnieDisplayName();
	return <>{t("annie.launcher.tooltip", { name: annieName })}</>;
};
